import React from "react";
import { Avatar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useActiveChannel } from "../contexts/ActiveChannelContext";

const LiquidGlassAvatar = styled(Avatar)(({ theme }) => ({
  borderRadius: "50%",
  cursor: "pointer",
  width: 56,
  height: 56,
  position: "relative",
  backgroundColor: "rgba(0, 0, 0, 0.03)",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  backdropFilter: "blur(24px) saturate(180%)",
  WebkitBackdropFilter: "blur(24px) saturate(180%)",
  boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.08)",
  transition: "transform 0.25s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "scale(1.06)",
    boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.1), 0 6px 16px rgba(0, 0, 0, 0.12)",
  },
  // Ensure the image inside is properly centered and covers the container
  "& .MuiAvatar-img": {
    objectFit: "cover",
    objectPosition: "center center",
    width: "100%",
    height: "100%",
  },
}));

const UserAvatar = ({ userData, width = 56, height = 56, onClick }) => {
  const navigate = useNavigate();
  const { setHasActiveChannel } = useActiveChannel();

  const handleClick = (e) => {
    // Prevent event bubbling if necessary
    e.stopPropagation();

    // 1. If a close handler was passed (e.g. from a Modal), execute it
    if (typeof onClick === "function") {
      onClick();
    }

    // 2. Clear active channel state so navbar shows on profile page
    setHasActiveChannel(false);

    // 3. Perform navigation - always use username
    if (userData?.username) {
      navigate(`/profile/${userData.username}`);
    } else if (process.env.NODE_ENV === "development") {
      console.error(
        "UserAvatar: Cannot navigate - username is missing:",
        userData,
      );
    }
  };

  return (
    <LiquidGlassAvatar
      alt={userData?.name}
      src={userData?.avatar}
      sx={{ width, height }}
      onClick={handleClick}
    />
  );
};

export default UserAvatar;
